import ILoan from "@/module/main/model/applicationForm/ILoan";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";
import ClientType from "@/module/main/dto/ClientTypeEnum";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import FinancingType from "@/module/main/dto/FinancingTypeEnum";
import CashFinancingType from "@/module/main/dto/CashFinancingTypeEnum";
import YesNo from "@/app/service/YesNoEnum";

export default class Loan implements ILoan {
    constructor(
        public totalPrice: string = "",
        public preferredInstallment: string = "",
        public preferredDownPayment: string = "",
        public productCode: string = "",
        public productSetCode: string = "",
        public financedSubjectType: FinancedSubjectType = FinancedSubjectType.CASH,
        public orderNumber: string = "",
        public clientType: ClientType = ClientType.PERSON,
        public orderType: OrderType = OrderType.STANDARD,
        public financingType: FinancingType = FinancingType.INSTALLMENT,
        public cashFinancingType: CashFinancingType = CashFinancingType.LOAN_WALLET,
        public walletWithOrder: YesNo = YesNo.NO,
    ) {
    }
}
